export default __webpack_public_path__ + "static/media/gallery_00.52f6b783.jpg";